import React, { useState } from "react";
import { Box, Typography, IconButton, Button } from "@mui/material";
import { X, Copy, CheckCircle } from "phosphor-react";

const CopyApiKeyModal = ({ handleClose, apiKey, setSnackValue }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      setSnackValue({ isOpen: true, message: "API Key copied to clipboard", isError: false });
    });
  };

  return (
    <Box
      sx={{
        backgroundColor: "#1B1D28",
        borderRadius: "20px",
        width: "600px",
        padding: "24px",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <Typography sx={{ fontSize: "24px", fontWeight: 500, color: "#F9F9F9" }}>
          Copy API Key
        </Typography>
        <IconButton onClick={handleClose} size="small" sx={{ color: "#F9F9F9" }}>
          <X size={32} />
        </IconButton>
      </Box>

      {/* Key row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#252A38",
          borderRadius: "8px",
          padding: "18px",
          gap: "10px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: 0 }}>
          <CheckCircle size={20} weight="fill" color="#00FF444D" style={{ flexShrink: 0 }} />
          <Typography
            sx={{
              fontSize: "14px",
              color: "#ECECEC",
              fontFamily: "monospace",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {apiKey}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          startIcon={<Copy size={16} />}
          onClick={handleCopy}
          sx={{
            color: copied ? "#65D984" : "#F9F9F9",
            borderColor: copied ? "#65D984" : "#6C65D9",
            borderRadius: "5px",
            textTransform: "none",
            fontSize: "14px",
            flexShrink: 0,
            padding: "4px 12px",
            "&:hover": {
              borderColor: copied ? "#65D984" : "#6C65D9",
              backgroundColor: copied ? "#65D98415" : "#6C65D915",
            },
          }}
        >
          {copied ? "Copied!" : "Copy"}
        </Button>
      </Box>
    </Box>
  );
};

export default CopyApiKeyModal;
